/*=========================================================================================
  File Name: mutations.js
  Namespace: videos
  Description: Vuex Store - Video mutations
==========================================================================================*/
import {
  buildVideoState
} from './state'

const mutations = {
  STORE_CURRENT_VIDEO(state, video) {
    state.currentVideo = { ...state.currentVideo, ...video }
  },
  RESET_CURRENT_VIDEO(state) {
    state.currentVideo = buildVideoState()
    state.currentVideoFiles = []
  },
  STORE_LIST_VIDEOS(state, videos) {
    state.videoList = {
      ...state.videoList,
      ...videos.entries
    }
    state.count = videos.count
    state.next = videos.next
    state.previous = videos.previous
    state.results = [...videos.results]
  },
  STORE_VIDEO_TO_LIST(state, video) {
    state.videoList = {
      ...state.videoList,
      ...video
    }
  },
  STORE_CURRENT_VIDEO_FILES(state, files) {
    state.currentVideoFiles = files
  },
  CHANGE_FILE_IN_VIDEO(state, payload) {
    const fileChanged = state.currentVideoFiles[state.currentVideoFiles.indexOf(payload.file)]
    fileChanged.name = payload.name
  },
  RESET_FILES_IN_VIDEO(state) {
    state.currentVideoFiles = []
  }
}

export default mutations

